<template>
  <div class="task-evaluation-back">
    <!--环图片-->
    <div class="img-box">
      <div class="prop-up"></div>
      <img src="@/assets/img/circle.png" class="circle" alt="">
    </div>
    <div>
      <!--题目-->
      <div class="subject">
        <div>任务是否完成？</div>
      </div>
      <!--选项-->
      <div style="width:115px;margin:calc(0.073 * var(--body-height)) auto 0;">
        <el-radio-group v-model="completed" @input="nextClick">
          <el-radio :label="2">完成</el-radio>
          <el-radio :label="1">部分完成</el-radio>
          <el-radio :label="0">未完成</el-radio>
        </el-radio-group>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "nature1",
  data() {
    return {
      //任务是否完成
      completed: '',
    }
  },
  computed: {
    ...mapGetters([
     
    ]),
  },
  mounted() {
    this.$store.commit('SET_ANSWER_PERCENT', 100)
  },
  methods: {

    /**
     * 下一题
     */
    nextClick() {
     
      //保存答案
      localStorage.setItem('taskCompleted',this.completed);
    
      // 跳转页面
      if (this.completed == 2) { //完成
        this.$router.push('/task_evaluation_finished')
      } else {
        this.$router.push('/task_evaluation_unfinished')
      }
    }


  }
}
</script>


<style scoped lang="less">
.task-evaluation-back {
  width: 100%;
  height: 100%;
  background-image: url("../../assets/img/ecoBack.png");
  background-size: cover;
}
</style>